import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlightDurationPipe } from './flight-duration.pipe';

@NgModule({
  declarations: [FlightDurationPipe],
  imports: [CommonModule],
  exports: [FlightDurationPipe]
})
export class FlightDurationModule {}
